angular.module('moebiusProadapt').controller('ctrlParticipantPecTherapeutique',
    ['$rootScope', '$scope', '$http', 'moment', '$timeout', '$location', '$controller', 'mbsEtiService', 'mbsParticipantService', '$uibModal','eti','questionVisite','participant','questionMere','linkedObject',
        function ($rootScope, $scope, $http, moment, $timeout, $location, $controller, mbsEtiService, mbsParticipantService, $uibModal, eti, questionVisite, participant, questionMere,linkedObject) {

            $scope.pec_therapeutique   = linkedObject;

            $scope.title        = questionMere.name;
            $scope.titleConfirm = 'OK';

            if ($scope.pec_therapeutique.editOrSave === 'SAVE') {
                $scope.title        = $scope.title + '-' + 'Ajout';
                $scope.titleConfirm = 'Ajouter';

            } else {
                $scope.title        = $scope.title + '-' + 'Edition';
                $scope.titleConfirm = 'Modifier';
            }

            //prepare lists for fields
            $scope.type_traitement_list = [];
            _.each($rootScope.constants.type_traitement_therapeutique_list.VALUES_TO_DISPLAY,function(value,key){
                $scope.type_traitement_list.push({id:key,label:value});
            });

            $scope.type_chirurgie_list = {
                "resection_tumeur_primitive" : "Résection tumeur primitive",
                "resection_tumeur_primitive_metastases" : "Résection tumeur primitive et métastase(s)",
                "resection_metastases" : "Résection métastase(s)"
             } ;

            if(typeof $scope.pec_therapeutique.classe_molecule === "string") {
                $scope.pec_therapeutique.classe_molecule = JSON.parse($scope.pec_therapeutique.classe_molecule);
            }

            $scope.classe_molecule_list = {
                "chimio_anti_metabolite": "Chimiothérapie : anti-métabolite",
                "chimio_agent_intercalant": "Chimiothérapie : agent-intercalant",
                "chimio_alkylant" : "Chimiothérapie : alkylant",
                "chimio_topoisomerase" : "Chimiothérapie : inhibiteur de la topoisomérase",
                "chimio_poison_fuseau_mitotique" : "Chimiothérapie : poison du fuseau mitotique",
                "chimio_autres" : "Chimiothérapie : autres",

                "hormonotherapie_agoniste_LH_RH" : "Hormonothérapie : agoniste de la LH-RH",
                "hormonotherapie_antagoniste_LH_RH" : "Hormonothérapie : antagoniste de la LH-RH",
                "hormonotherapie_anti_androgene_steroidien" : "Hormonothérapie : anti androgène stéroïdien",
                "hormonotherapie_anti_androgene_non_steroidien" : "Hormonothérapie : anti androgène non stéroïdien",
                "hormonotherapie_inhibiteur_synthese_androgenes" : "Hormonothérapie : inhibiteur de la synthèse des androgènes",
                "hormonotherapie_inhibiteur_recepteurs_androgenes" : "Hormonothérapie : inhibiteur des récepteurs aux androgènes",
                "hormonotherapie_anti_estrogenes" : "Hormonothérapie : anti-estrogènes",
                "hormonotherapie_anti_aromatase" : "Hormonothérapie : anti-aromatase",
                "hormonotherapie_progestatif": "Hormonothérapie : progestatif",
                "hormonotherapie_autre": "Hormonothérapie : autre",

                "traitement_cible_anticorps_monoclonaux": "Traitement ciblé : anticorps monoclonaux",
                "traitement_cible_molecule_inhibitrice": "Traitement ciblé : molécule inhibitrice",
                "traitement_cible_autre" : "Traitement ciblé : autre"
            };

            // -- init
            if ($scope.pec_therapeutique.date_debut) {
                $scope.pec_therapeutique.date_debut = moment($scope.pec_therapeutique.date_debut).hour(12).toDate();
            }
            if ($scope.pec_therapeutique.date_fin) {
                $scope.pec_therapeutique.date_fin = moment($scope.pec_therapeutique.date_fin).hour(12).toDate();
            }
            if ($scope.pec_therapeutique.date_examen) {
                $scope.pec_therapeutique.date_examen = moment($scope.pec_therapeutique.date_examen).hour(12).toDate();
            }
    }]
);


// WEBPACK FOOTER //
// ./resources/assets/js/controllers/etude/participantPecTherapeutique.js